module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Acknowledgements#ack"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_List#list"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("List of Illustrations")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Introduction#int"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#chapter1"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 1")])]), _vm._v(" Military Railways")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter02#chapter2"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 2")])]), _vm._v(" Railways Before the Second World War")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 3")])]), _vm._v(" 1939")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter04#chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 4")])]), _vm._v(" 1940")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter05#chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 5")])]), _vm._v(" 1941")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter06#chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 6")])]), _vm._v(" 1942")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07#chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 7")])]), _vm._v(" 1943")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 8")])]), _vm._v(" 1944")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter09#chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 9")])]), _vm._v(" 1945")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter10#chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 10")])]), _vm._v(" Reflection")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocat"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Afterword#after",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Afterword")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Appendix01#app1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Appendix I")])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Second World War Railway Memorials")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Appendix02#app2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Appendix II")])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Commemorative Second World War Locomotives and Railway vehicles")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocat"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Glossary#glos",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Glossary")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Bibliography#bib",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bibliography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-132b06ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 72
// module chunks = 0